import React, { useEffect, useState } from 'react'

import { Col, Modal, Row } from 'antd'

import Icon from '../../general/Icon'

import './styles.less'

interface DeleteConfirmModalProps {
  title: string
  visible: boolean
  content?: string
  onDelete?: () => void
  onCancel?: () => void
  deleteButtonLoading?: boolean
}

const DeleteConfirmModal = (props: DeleteConfirmModalProps) => {
  const [visible, setVisible] = useState<boolean>()

  useEffect(() => {
    setVisible(props.visible)
  }, [props.visible])

  const onCancel = () => {
    setVisible(false)
    if (props.onCancel) {
      props.onCancel()
    }
  }

  return (
    <Modal
      className={'delete-confirm-modal'}
      open={visible}
      width={400}
      onOk={props.onDelete}
      okText={'Delete'}
      okButtonProps={{ loading: props.deleteButtonLoading, disabled: props.deleteButtonLoading }}
      closable={false}
      onCancel={onCancel}
    >
      <Row>
        <Col span={3} className={'icon-wrapper'}>
          <Icon className={'fas fa-question-circle'} />
        </Col>
        <Col span={21}>
          <p className={'title'}>{props.title}</p>
          {props.content && <p className={'content'}>{props.content}</p>}
        </Col>
      </Row>
    </Modal>
  )
}

export default DeleteConfirmModal
